/**
 * REV22 Fix 2b (docs/specs/REV22-hexa-stat-and-merged-masteries.md) — the "≈" prefix a fragment/Sol
 * Erda figure gets whenever it includes HEXA Stat's expected-value leveling cost, with a `title`
 * tooltip explaining why. Shared by `components/goals/HexaSection.tsx` (the goal-progress card and
 * each stat card's cost line) and `components/hexa/HexaOverview.tsx` (the roster totals strip and
 * per-character rows) so every HEXA summary surface reads consistently.
 */
export function EstimatePrefix({ estimated }: { estimated: boolean }) {
  if (!estimated) {
    return null;
  }
  return (
    <span
      className="cursor-help"
      title="Includes HEXA Stat leveling cost — an expected-value estimate, not an exact figure (the actual RNG path is unknowable)."
    >
      ≈
    </span>
  );
}
